{
  "side-bar": {
    "main": {
      "subtitle": "Головна",
      "sphere-name": "Рівень добробуту"
    }
  },

  "hmt-dashboard": {
    "linear-chart": {
      "title": "Рівень добробуту"
    },
    "imminent-risk": {
      "title": "Групи підвищеної уваги",
      "subtitle": "Показує кількість учасників, у яких система виявила критичні сигнали — наприклад, ризик самозагрози або небезпеки для оточення."
    },
    "recommendations": {
      "title": "Загальні рекомендації для учасників"
    }
  },

  "spheres-dashboard": {
    "scale-list": {
      "title": "Які шкали включає сфера?"
    },
    "recommendations": {
      "title": "Рекомендації, що підтримають учасників"
    }
  },
  "recommendations": {
    "buttons": {
      "open": "Детальна рекомендація",
      "close": "Закрити"
    }
  },
  "disclaimer": {
    "text": "Результати діагностики мають інформаційний характер і не є діагнозом. За потреби вони можуть стати приводом для консультації з фахівцем з ментального здоров’я.",
    "close": "Закрити"
  }
}
